import { TableHeadersType } from "../tableHeadersType";

export const RecurringJobsTableHeader:TableHeadersType[]=[
    {
        "label": "JOB TYPE*",
        "value": "Job Type",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "DESCRIPTION*",
        "value": "Description",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "NEXT JOB DATE*",
        "value": "Next Job Date",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "MANAGER*",
        "value": "Manager",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "RESPONSIBLE*",
        "value": "Responsible",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "OFFICER",
        "value": "Govt Officer",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CUTOFF DATE",
        "value": "Engagement cutoff date",
        "defaultChecked": true,
        "checked": true
    }
] 